import React from 'react';
import { Tooltip } from '@material-ui/core';

import { buildCommonInvoiceCells } from './build-common-invoice-cells.util';
import { DeliveryPointsScopes } from '../types/delivery-points-scope.type';
import type { OrganizationInvoice, InvoiceOrganizationParams } from '../types/invoice.type';
import type { InvoiceStatus } from '../types/invoice-status.type';
import type { InvoiceTableRow } from '../components/Tables/InvoiceListTable.component';

type Options = {
  onChangeStatus: (invoiceId: string, nextStatus: InvoiceStatus) => void | Promise<void>;
};

function renderWithNamesTooltip(label: string, names: string[]): React.ReactNode {
  return (
    <Tooltip title={names.join(', ')}>
      <span>{label}</span>
    </Tooltip>
  );
}

function renderDeliveryPoints(params: InvoiceOrganizationParams): React.ReactNode {
  const names = params.deliveryPoints.map((deliveryPoint) => deliveryPoint.nameSnapshot);

  if (params.deliveryPointsScope === DeliveryPointsScopes.ALL) {
    // Portée ALL : on montre quand même le snapshot figé pour rester lisible après renommage.
    return renderWithNamesTooltip(`Tous (${names.length})`, names);
  }

  if (names.length <= 2) return names.join(', ');

  return renderWithNamesTooltip(`${names[0]} +${names.length - 1}`, names);
}

export function mapOrganizationInvoiceToTableRow(
  invoice: OrganizationInvoice,
  options: Options,
): InvoiceTableRow {
  const cells = buildCommonInvoiceCells(invoice, invoice.organizationParams.interval, options);

  return {
    id: invoice.id,
    status: invoice.status,
    cells: [
      cells.invoiceNumber,
      cells.status,
      cells.format,
      { key: 'deliveryPoints', content: renderDeliveryPoints(invoice.organizationParams) },
      cells.period,
      cells.totalHT,
      cells.totalTTC,
      cells.createdAt,
    ],
  };
}
